import React from 'react'
import { StickyArticleHeader } from '../../../../common/components'
import styles from '../../../../common/scss/content.module.scss'

const ArticleStickyHeader = ({ location, article, stickyHeaderShown, tokens }) => {
  return (
    <div
      className={`${styles.stickyArticleHeaderWrapper}${stickyHeaderShown && ' '
        }${stickyHeaderShown && styles.stickyArticleHeaderWrapperIsShown}`}
    >
      <StickyArticleHeader
        tokens={tokens}
        article={article}
        location={location}
        scrollIndicator
      />
    </div>
  )
}

export default ArticleStickyHeader
